import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { startWith } from 'rxjs/operators';

@Component({
    selector: 'app-password-requirements',
    templateUrl: './password-requirements.component.html',
    styleUrls: ['./password-requirements.component.scss'],
    standalone: false
})
export class PasswordRequirementsComponent implements OnInit, OnDestroy {
    @Input() passwordControl: AbstractControl | null = null;

    isVisible = true;
    private passwordValueSubscription?: Subscription;

    ngOnInit(): void {
        if (this.passwordControl) {
            this.passwordValueSubscription = this.passwordControl.valueChanges
                .pipe(
                    startWith(this.passwordControl.value)
                )
                .subscribe(currentValue => {
                    this.isVisible = !this.arePasswordRequirementsMet(currentValue || '');
                });
        }
    }

    ngOnDestroy(): void {
        this.passwordValueSubscription?.unsubscribe();
    }

    /**
     * Validates password against security requirements:
     * - Minimum 6 characters
     * - At least 1 uppercase letter (A-Z)
     * - At least 1 lowercase letter (a-z)
     * - At least 1 number (0-9)
     * - At least 1 special character (!@#$%^&*?-)
     * @param passwordValue - The password string to validate
     * @returns true if all requirements are met, false otherwise
     */
    private arePasswordRequirementsMet(passwordValue: string): boolean {
        if (!passwordValue) return false;

        const meetsMinLength = passwordValue.length >= 6;
        const hasUppercaseChar = /[A-Z]/.test(passwordValue);
        const hasLowercaseChar = /[a-z]/.test(passwordValue);
        const hasNumericChar = /\d/.test(passwordValue);
        const hasSpecialChar = /[!@#$%^&*?-]/.test(passwordValue);

        return meetsMinLength && hasUppercaseChar && hasLowercaseChar && hasNumericChar && hasSpecialChar;
    }
}
